import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, createInvalidWarehouseSection, PreventionInvalidityCode, PreventativeAutocompleteType} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.warehouseAlertThresholds,
    sections: [
        createInvalidPartSection('partNo'),
        createInvalidWarehouseSection('warehouseCode'),
        {
            sectionKey: 'missingWarehouseAlertFields',
            sectionTitle: 'Missing Required Threshold Fields',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: 'warehouseCode',
                    label: 'Warehouse',
                    type: PreventativeAutocompleteType.WAREHOUSE,
                    extractValue: (o) => typeof o === 'string' ? o : o?.code ?? null,
                    modifyRow: (row, val) => ({...row, warehouseCode: val}),
                    autocompleteProps: {
                        placeholder: 'Search for warehouse...',
                        getOptionLabel: (o) => o?.name ? `${o.name} (${o.code})` : o?.code ?? '',
                        isOptionEqualToValue: (o, v) => o?.code === v?.code,
                    },
                },
                {
                    key: 'partNo',
                    label: 'Part Number',
                    type: PreventativeAutocompleteType.PART,
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNo ?? null,
                    modifyRow: (row, val) => ({...row, partNo: val}),
                    autocompleteProps: {
                        placeholder: 'Search for part...',
                        getOptionLabel: (o) => o?.partNo ?? '',
                        isOptionEqualToValue: (o, v) => o?.partNo === v?.partNo,
                    },
                },
                {
                    key: 'reOrderPoint',
                    label: 'Re-Order Point',
                    type: 'input',
                    textFieldProps: {inputProps: {type: 'number', min: 0}},
                    modifyRow: (row, val) => ({...row, reOrderPoint: val})
                },
                {
                    key: 'minimumOrder',
                    label: 'Minimum Order',
                    type: 'input',
                    textFieldProps: {inputProps: {type: 'number', min: 0}},
                    modifyRow: (row, val) => ({...row, minimumOrder: val})
                }
            ]
        },
    ],
};
